// extracted by mini-css-extract-plugin
export default {"inline":"LoadingIndicator_inline__54aP6","spinner":"LoadingIndicator_spinner__0F9L7","loading-spin":"LoadingIndicator_loading-spin__p-IH-"};